import React, { useRef, useEffect, ReactNode } from "react";

import { useAliveScope } from "context/AliveScopeProvider";

interface Props {
  id: string;
  children: ReactNode;
}
//for future reference, this and the AliveScope context were taken from https://codesandbox.io/s/react-portal-keep-alive-ingxb?file=/src/Providers/AliveScope.js
const KeepAlive = (props: any) => {
  const { id, children } = props;

  const { getPortalElement } = useAliveScope();

  const keepAliveRef = useRef<HTMLDivElement>(null);

  const appendPortalElement = () => {
    const portalElement = getPortalElement(id, children);
    if (keepAliveRef.current != null) {
      keepAliveRef.current.appendChild(portalElement);
    };
  };

  useEffect(() => {
    appendPortalElement();
  }, []);

  return <div ref={keepAliveRef} />;
};

export default KeepAlive;
